// Module-scoped request cache, shared by all modules. Lives outside React
// state so it survives a panel unmounting on tab switch. Stores the promise,
// so parallel requests for the same key only fetch once; failed requests are
// evicted so they can be retried.
const cache = new Map();

export function cachedLoad(key, loader) {
  if (!cache.has(key)) {
    cache.set(
      key,
      loader().catch((err) => {
        cache.delete(key);
        throw err;
      }),
    );
  }
  return cache.get(key);
}
